import messages from './Messages';
import Select from '../../../../components/Select';
import cloneDeep from 'lodash/cloneDeep';
import { IOption } from '../../../../components/Select/Select';
import Button from '../../../../components/Button';
import Icon from '../../../../components/Icon';
import { generateRandomString } from '../../../../utils/string';
import Collapsible from '../../../../components/Collapsible';
import { Card } from '../CompanyRoles/styles';
import { DeleteIcon } from '../../../../components/SurveyResponses/styles';
import { Mention, MentionsInput } from 'react-mentions';
import { withTitle } from '../../../../components/withTitle';
import { ClassPhaseProp } from 'store/companies/companiesTypes';
import i18n from '../../../../i18n';

const offsetTimes = [
  -60 * 24 * 7,
  -60 * 24,
  -60 * 12,
  -60 * 5,
  -60 * 2,
  -60,
  -30,
  -10,
  0,
  10,
  30,
  60,
  60 * 2,
  60 * 5,
  60 * 12,
  60 * 24,
  60 * 24 * 7,
  60 * 24 * 15,
  60 * 24 * 30,
  60 * 24 * 60,
  60 * 24 * 90,
  60 * 24 * 180,
];
const offsetTimesOptions = offsetTimes.map((it) => ({
  value: it,
  label: messages.getTimeOffsetMessage(it),
}));

const notificationsPatternData = [
  { id: 'sd', display: 'زمان شروع' },
  { id: 'ed', display: 'زمان پایان' },
  { id: 'cl', display: 'لینک به صفحه دوره' },
  { id: 'classLocation', display: 'محل برگزاری دوره' },
];
interface IComponentProps {
  phaseProps: ClassPhaseProp;
  updatePhase: (phaseProps: ClassPhaseProp) => void;
}

export const PhaseReminder: React.FC<IComponentProps> = ({
  updatePhase,
  phaseProps,
}) => {
  const targetGroupOptions = [
    {
      value: 'Participants',
      label: i18n.t('Participants', { ns: 'companyManagement' }),
    },
    {
      value: 'RejectedParticipants',
      label: i18n.t('RejectedParticipants', { ns: 'companyManagement' }),
    },
    {
      value: 'Manager',
      label: i18n.t('Manager', { ns: 'companyManagement' }),
    },
    {
      value: 'Teacher',
      label: i18n.t('Teacher', { ns: 'companyManagement' }),
    },
  ];

  const targetTimeOptions = [
    {
      value: 'StartDate',
      label: i18n.t('StartDatePhase', { ns: 'companyManagement' }),
    },
    {
      value: 'EndDate',
      label: i18n.t('EndDatePhase', { ns: 'companyManagement' }),
    },
  ];

  function setValue(index: number, values: IOption[], field: string) {
    const clone = cloneDeep(phaseProps);
    clone.reminders![index][field] = values[0].value;
    updatePhase(clone);
  }

  const addReminder = () => {
    const clone = cloneDeep(phaseProps);
    if (!clone.reminders) {
      clone.reminders = [];
    }
    clone.reminders.push({
      localId: generateRandomString(10),
      targetGroup: 'Participants',
      targetTime: 'StartDate',
      timeOffsetM: 0,
    });
    updatePhase(clone);
  };
  const removeReminder = (index: number) => {
    const clone = cloneDeep(phaseProps);
    if (!clone.reminders) {
      clone.reminders = [];
    }
    clone.reminders.splice(index, 1);
    updatePhase(clone);
  };

  return (
    <Collapsible
      iconName={'clock'}
      header={messages.remindercount(phaseProps.reminders?.length)}
    >
      <div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {phaseProps.reminders?.map((reminder, index) => {
            return (
              <Card
                key={reminder.localId}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  flex: '0 0 450px',
                  justifyContent: 'center',
                  // minWidth: '400px !important',
                  // maxWidth: '400px !important',
                  // width: '400px !important',
                  // flexShrink: 0,
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                    width: '450px',
                    justifyContent: 'center',
                    // minWidth: '400px !important',
                    // maxWidth: '400px !important',
                    // width: '400px !important',
                    // flexShrink: 0,
                    position: 'relative',
                  }}
                >
                  <Select
                    containerStyle={{ flex: 1 }}
                    options={targetGroupOptions}
                    values={targetGroupOptions.filter(
                      (it) => it.value === reminder.targetGroup
                    )}
                    onChangeValues={(values) => {
                      setValue(index, values, 'targetGroup');
                    }}
                    label={
                      i18n.t('targetGroup', {
                        ns: 'companyManagement',
                      }) as string
                    }
                    allowRemove={false}
                    multiChoice={false}
                  />
                  <Select
                    containerStyle={{ flex: 1 }}
                    options={offsetTimesOptions}
                    values={offsetTimesOptions.filter(
                      (it) => it.value === reminder.timeOffsetM
                    )}
                    onChangeValues={(values) => {
                      setValue(index, values, 'timeOffsetM');
                    }}
                    label={
                      i18n.t('offsetTime', {
                        ns: 'companyManagement',
                      }) as string
                    }
                    allowRemove={false}
                    multiChoice={false}
                  />
                  <Select
                    containerStyle={{ flex: 1 }}
                    options={targetTimeOptions}
                    values={targetTimeOptions.filter(
                      (it) => it.value === reminder.targetTime
                    )}
                    onChangeValues={(values) => {
                      setValue(index, values, 'targetTime');
                    }}
                    label={
                      i18n.t('targetTime', {
                        ns: 'companyManagement',
                      }) as string
                    }
                    allowRemove={false}
                    multiChoice={false}
                  />
                </div>
                <div
                  style={{
                    minHeight: '89px',
                  }}
                >
                  {withTitle(
                    <MentionsInput
                      value={reminder.message || ''}
                      onChange={(_: any, newValue: string) => {
                        setValue(
                          index,
                          [{ value: newValue, label: '' }],
                          'message'
                        );
                      }}
                      forceSuggestionsAboveCursor={true}
                      allowSuggestionsAboveCursor={true}
                      allowSpaceInQuery={true}
                      className="surveySMSPattern"
                      placeholder={
                        i18n.t('messagePattern', {
                          ns: 'companyManagement',
                        }) as string
                      }
                    >
                      <Mention
                        trigger={'%'}
                        data={notificationsPatternData}
                        markup={'%__id__%'}
                        displayTransform={(id: string) =>
                          '(' +
                          (notificationsPatternData.find((it) => it.id === id)
                            ?.display || id) +
                          ')'
                        }
                        appendSpaceOnAdd={true}
                      />
                      <Mention
                        trigger={'٪'}
                        data={notificationsPatternData}
                        markup={'%__id__%'}
                        displayTransform={(id: string) =>
                          '(' +
                          (notificationsPatternData.find((it) => it.id === id)
                            ?.display || id) +
                          ')'
                        }
                        appendSpaceOnAdd={true}
                      />
                    </MentionsInput>,
                    i18n.t('usePercentToGetOptions', {
                      ns: 'companyManagement',
                    }) as string,
                    'bottom'
                  )}
                </div>
                <DeleteIcon
                  type={'x'}
                  onClick={() => {
                    removeReminder(index);
                  }}
                />
              </Card>
            );
          })}
        </div>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          <Button color={'green'} onClick={addReminder}>
            <Icon type="plus" />
            {
              i18n.t('addReminder', {
                ns: 'companyManagement',
              }) as string
            }
          </Button>
        </div>
      </div>
    </Collapsible>
  );
};
